export const NuxtRoutes = Object.freeze({
    PRODUCTS: {
        BUY_PREMIUM: '/users/products/buy-premium',
    },
    CHECKOUT: {
        BUY_CREDITS: '/checkout/buy-credits/'
    },
    USERS: {
        STORIES: '/account/stories/',
        STORIES_CREATE: '/account/stories/create/',
        ACCOUNT_EDIT: '/users/account/edit',
        MESSAGES: '/users/account/messages/',
        MEDIA_REPOSITORY: '/users/account/media-repository',
        PRIVATE_GALLERIES: '/users/profile/galerie/',
    },
    CHATTER: {
        CRM: '/chatter-crm',
    },
});
